import type React from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'

interface Props {
  placeholder: string
  hideDivider?: boolean
  themeBold: boolean
}

export const SeoPlaceholderBlock: React.FC<Props> = ({
  placeholder,
  hideDivider,
  themeBold,
}) => (
  <div className={clsJoin(css.seo_block, css.placeholder)}>
    <div className={clsJoin(css.seo_block_placeholder, themeBold && css.bold)}>
      {placeholder}
    </div>
    {!hideDivider && <div className={css.seo_block_divider} />}
  </div>
)
